import { Box } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { colors } from '../../const/colors'

export function NameCell({ value }: { value: string }) {
  return (
    <Box component="span" sx={{ fontWeight: 700 }}>
      {value}
    </Box>
  )
}

export function MutedCell({ value }: { value: string }) {
  return (
    <Box component="span" sx={{ color: colors.textMuted, fontSize: '13.5px' }}>
      {value || '—'}
    </Box>
  )
}

export function ProfileCell({ value }: { value: string }) {
  if (!value || value === '-') {
    return (
      <Box component="span" data-e2e="profile-cell" sx={{ color: colors.slateLight, fontSize: '13px' }}>
        —
      </Box>
    )
  }
  if (value === 'VIP') {
    return (
      <Box
        component="span"
        data-e2e="profile-cell"
        sx={{
          display: 'inline-block',
          background: 'linear-gradient(135deg,#F4D24A,#EDBD01)',
          color: colors.navy,
          fontWeight: 700,
          fontSize: '12px',
          px: '10px',
          py: '4px',
          borderRadius: colors.radiusTag,
        }}
      >
        VIP
      </Box>
    )
  }
  return (
    <Box component="span" data-e2e="profile-cell" sx={{ color: colors.navy, fontWeight: 700, fontSize: '13px' }}>
      {value}
    </Box>
  )
}

export function BuildingCell({ value }: { value: string }) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        background: colors.border,
        color: colors.textAccent,
        fontSize: '12.5px',
        fontWeight: 600,
        px: '11px',
        py: '5px',
        borderRadius: colors.radiusTag,
      }}
    >
      {value || '—'}
    </Box>
  )
}

export function ParkingsCell({ value }: { value: string }) {
  const names = (value || '').split(', ').filter(Boolean)
  if (!names.length) {
    return (
      <Box component="span" sx={{ color: colors.slateLight, fontSize: '13px' }}>
        —
      </Box>
    )
  }
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
      {names.map(name => (
        <Box
          key={name}
          component="span"
          sx={{
            background: colors.border,
            color: colors.textAccent,
            fontSize: '12.5px',
            fontWeight: 600,
            px: '11px',
            py: '5px',
            borderRadius: colors.radiusTag,
            whiteSpace: 'nowrap',
          }}
        >
          {name}
        </Box>
      ))}
    </Box>
  )
}

export function ServiceCell({ value, yesLabel }: { value: string; yesLabel: string }) {
  const isAssigned = value === yesLabel
  return (
    <Box
      component="span"
      data-e2e="service-cell"
      sx={{
        display: 'inline-block',
        background: isAssigned ? colors.greenBg : colors.redBg,
        color: isAssigned ? colors.green : colors.red,
        fontWeight: 700,
        fontSize: '12.5px',
        px: '11px',
        py: '4px',
        borderRadius: colors.radiusTag,
      }}
    >
      {value}
    </Box>
  )
}

export function ReadinessCell({ value, isReady }: { value: string; isReady: boolean }) {
  if (isReady) {
    return (
      <Box
        component="span"
        aria-label={value}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 25,
          height: 25,
          borderRadius: '50%',
          background: colors.greenBg,
          color: colors.green,
        }}
      >
        <CheckIcon
          sx={{ fontSize: 16, stroke: 'currentColor', strokeWidth: 1.5 }}
        />
      </Box>
    )
  }
  return (
    <Box
      component="span"
      sx={{ color: colors.slateLight, fontSize: '13px', fontWeight: 700 }}
    >
      {value}
    </Box>
  )
}
